import React from "react";

const StatutoryTax = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M28.53 15.648V2.94A.941.941 0 0027.59 2H2.94A.941.941 0 002 2.941v25.24a1.53 1.53 0 001.505 1.529 1.535 1.535 0 001.497-1.529v-9.296-.04a3.331 3.331 0 013.337-3.197H28.53zm-9.086-8.902a.941.941 0 111.454-1.197l1.41 1.714L23.72 5.55a.941.941 0 011.454 1.197l-1.645 1.999 1.645 2a.94.94 0 01-1.454 1.195l-1.41-1.714-1.412 1.714a.94.94 0 11-1.453-1.196l1.646-2-1.646-1.998zm-7.977 1.539a3.083 3.083 0 013.08-3.08 3.082 3.082 0 013.078 3.08v3.057a.94.94 0 11-1.883 0v-.73H13.35v.73a.941.941 0 11-1.883 0V8.285zm-4.07 3.999a.941.941 0 01-.942-.942V7.088H5.259a.94.94 0 110-1.882h4.275a.941.941 0 110 1.882H8.337v4.254a.94.94 0 01-.94.942z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M8.345 17.529h-.006c-.778 0-1.414.604-1.455 1.377v9.274c0 .549-.132 1.068-.366 1.53h3.285V18.986a1.46 1.46 0 00-1.458-1.458zM15.741 8.285c0-.66-.536-1.197-1.196-1.197-.66 0-1.196.537-1.196 1.197v.445h2.392v-.445zM32.544 17.529H11.352c.214.44.335.936.335 1.458V33.06c0 .52.421.941.94.941h20.434c.52 0 .941-.421.941-.941V18.987a1.46 1.46 0 00-1.458-1.458zM15.59 22.353h7.294a.94.94 0 110 1.882H15.59a.941.941 0 010-1.882zm7.34 6.964c-.046.002.399 0-7.34 0a.941.941 0 010-1.882h7.294a.94.94 0 01.046 1.882zm7.884 0h-3.577a.941.941 0 110-1.882h3.577a.941.941 0 010 1.883zm0-5.082h-3.577a.941.941 0 110-1.882h3.577a.941.941 0 010 1.882z"
            fill={fill}
        />
    </svg>
);

export default StatutoryTax;
